<template>
  <tender-form-label :key="index"
    :label="options.Name"
    :prop="realKey"
    :rules="rules"
    class="label-select-radio"
    show-msg
  >
    <el-radio v-for="(obj, i) in options.Options" :key="i"
      v-model="form[realKey]" 
      class="form-select-radio"
      :label="obj.Value"
      @change="selectChangeHandle"
    >{{obj.Name}}</el-radio>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import { mixForFormItem } from "../../../js/mixins"
import utils from '../../../js/utils'
import tenderHook from "../../../js/hooks"
import { mapState, mapGetters } from "vuex"
export default {
  name: 'FormSelectRadio',
  mixins: [mixForFormItem],
  data() {
    return {
    }
  },
  computed: {
    ...mapState(["selections"]),
    ...mapGetters(["properties"]),
    value() {
      return this.form[this.realKey]
    },
    realKey() {
      let {Key} = this.options
      let {trueValue} = this.param
      return trueValue ? `select_${Key}` : Key
    }
  },
  watch: {
    value() {
      this.doSelectEvent(true)
    }
  },
  created() {
    this.setDefaultValue()
    this.$nextTick(() => {
      this.doSelectEvent(true)
    })
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      let {Key, Value} = options
      let {trueValue} = this.param
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(trueValue) {
          form[`select_${Key}`] = Value || ''
          form[Key] = Value === trueValue
        } else {
          form[Key] = Value || ''
        }
      }).catch(() => null)
    },
    selectChangeHandle(value) {
      let {form = {}, options = {}} = this
      let {Key} = options
      let {trueValue} = this.param
      if(trueValue) {
        form[`select_${Key}`] = value
        form[Key] = value === trueValue
      } else {
        form[Key] = value
      }
      this.$nextTick(() => {
        // this.doValidate()
        this.doSelectEvent()
      })
    },
    doSelectEvent(isOnlySet) {
      let { form = {}, options = {}, properties } = this;
      let { Key, Refs = [] } = options;
      let { trueValue } = this.param;
      Refs.forEach((eRef) => {
        let [type, ...args] = eRef;
        switch (type) {
          case "setFormItemRequired":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemRequired(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemDisabled":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemDisabled(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemValue":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [keys, value, same] = args;
                if (same) {
                  tenderHook.setFormItemValue(form, keys, form[Key]);
                  if (trueValue) {
                    tenderHook.setFormItemValue(form, keys, form[`select_${Key}`]);
                  }
                } else {
                  tenderHook.setFormItemValue(form, keys, value);
                }
              });
            }
            break;
          case "setFormItemVisible":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, values] = args;
              let value = trueValue ? form[`select_${Key}`] : form[Key];
              // 接下来写设置可见操作
              tenderHook.setFormItemVisible(properties, chapterIndex, sectionIndex, keys, values.indexOf(value) >= 0);
            });
            break;
          case "setFormItemWithCustom":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [type, ...x] = args;
                // console.log(form[Key], Key, this.form, 333);
                tenderHook.setFormItemWithCustom(this, type, options, ...x);
              });
              // tenderHook.refEvent(null, this);
            }
            break;
          case "houseHooks":
          case "trafficHooks":
            tenderHook.refEvent(isOnlySet, this)
            break;
        }
      });
      this.doValidate();
    },
  }
}
</script>
<style lang="scss">
.form-select-radio {
  position: relative;
  z-index: 1;
  .el-radio {
    height: 25px;
  }
  .el-radio__inner {
    border-radius: 0;
    border-color: black;
  }
  .el-radio__label {
    color: black;
    font-size: auto;
  }
  .el-form-item__content {
    line-height: 25px;
  }
  &+.el-form-item__error {
    display: inline;
  }

}
.label-select-radio {
  &.tender-form-label.el-form-item--default,
  &.tender-form-label.el-form-item {
    .el-form-item__content {
      display: inline-block;
      padding: 2px 8px;
    }      
  }
  &.is-error {
    .el-form-item__error {
      top: 0;
      bottom: 0;
      right: 0;
      padding: 7px;
      text-align: right;
      color: #00000000;
      background: #efdede;
      border-bottom: 1px solid red;
    }
  }  
}
</style>